<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-text"></i> Match List
    </div>

    <div class="mb-2 d-flex gap-2 justify-content-end align-items-center">
      <!-- Search Bar -->
      

     
      <router-link :to="'/admin/tanding/match/' + poolId" class="button button-primary">
        <i class="bi bi-diagram-3"></i> View Bracket
      </router-link>
    </div>

    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th rowspan="2">Round</th>
            <th colspan="2" class="text-center blue-side">Blue</th>
            <th colspan="2" class="text-center red-side">Red</th>
            <th></th>
          </tr>
          <tr>
            
            <th class="blue-side text-center">Contingent</th>
            <th class="blue-side text-center">Participant</th>
            <th class="red-side text-center">Contingent</th>
            <th class="red-side text-center">Participant</th>
            <th style="width: 200px;"></th>
          </tr>
        </thead>
        <tbody v-if="matchList.length > 0">
          <tr v-for="match in matchList" :key="match.match_id">
            <td>{{ match.round }}</td>
            <td class="blue">{{ match.participant_one_contingent ?? '-' }}</td>
            <td class="blue">{{ match.participant_one ?? '-' }}</td>
            <td class="red">{{ match.participant_two_contingent ?? '-' }}</td>
            <td class="red">{{ match.participant_two ?? '-' }}</td>
            <td>
            <button
              type="button"
              class="button button-primary"
              :disabled="loading"
              @click="createOpponent(match.match_id)"
            >
              <span><i class="bi bi-clipboard-check"></i> Create Opponent</span>
            </button>
          </td>


          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">No data found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <!--
      BILAH HALAMAN DIHAPUS.

      Blok paginasi di sini hasil salin-tempel dari halaman lain dan tidak
      pernah disambungkan: `changePage`, `currentPage`, `totalPages`,
      `prevPageUrl`, dan `nextPageUrl` tidak ada satu pun di dalam skrip
      berkas ini, dan endpoint yang dipanggilnya memang tidak memaginasi
      apa-apa.

      Akibatnya bilah itu tampil sebagai dua panah kelabu yang tidak bisa
      ditekan, tanpa nomor halaman — kontrol yang tidak mungkin berfungsi,
      tapi terlihat seperti ada gunanya. Kalau nanti datanya benar-benar
      dipaginasi, pasang komponen paginasi yang sama dengan halaman lain,
      jangan salin blok ini lagi.
    -->
  </div>
</template>

<script>
import http from "@/services/http";
import { useToast } from "vue-toastification";
import { inject } from 'vue';

export default {
  name: "ContingentList",
  data() {
    return {
      poolId: null,
      deleteModal: null,
      matchList: [],
      errorMessage: null,
      loading: false,
      progress: 0,
    };
  },

  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []); // Ensure permissions is always an array
    
    return { toast, permissions };
  },
  mounted() {
    this.poolId = this.$route.params.id;
    this.loadMatchList(); // Corrected the method name
  },
  watch: {
    '$route.params.id': function(newId) {
      this.poolId = newId;
      this.loadMatchList();
    }
  },
  
  methods: {
    async createOpponent(matchId) {
      this.loading = true;
      try {
        await http.post(`/matches/${matchId}/create-dummy`);
        this.toast.success('Peserta dummy berhasil dibuat!');
        await this.loadMatchList(); // refresh list
      } catch (error) {
        console.error('Gagal membuat dummy:', error);
        this.toast.error(
          error.response?.data?.message || 'Gagal membuat dummy peserta'
        );
      } finally {
        this.loading = false;
      }
    },
    async generateBracket() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const response = await http.get(`/pools/${this.poolId}/matches`);
        // Bagan yang sudah berjalan tidak dibuat ulang.
        if (response.data.status !== 'ongoing') {
          await http.post(`/pools/${this.poolId}/generate-bracket`);
        }
        await this.loadMatchList();
      } catch (error) {
        console.error("Error generating bracket:", error);
        this.errorMessage = error?.response?.data?.message
          || error?.response?.data?.error
          || error?.message
          || "Gagal membuat bagan.";

        if (this.toast) {
          this.toast.error(this.errorMessage);
        }
      } finally {
        this.loading = false;
      }
    },
    async loadMatchList() {
      this.loading = true;
      try {
        const response = await http.get(`/pools/${this.poolId}/match-list`);
        const {
          data,
        } = response.data;

        this.matchList = data; // Assign team members
        this.loading = false;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

.table th,
.table td {
  padding: 10px;
}




input::placeholder {
    color: var(--text-muted);
    font-size: 15px;  /* Change font size */
    font-style: italic;  /* Change font style */
    opacity: 1;  /* Full opacity (default is 0.5) */
    font-family: 'Figtree', sans-serif;
}

.blue-side{
  background-color: #002FB9;
  color: #FFFFFF;
  text-transform: uppercase;
}

.blue{
  color:#002FB9;
}

.red{
  color: #F80000;
}

.red-side{
  background-color: #F80000;
  color: #FFFFFF;
  text-transform: uppercase;
}




.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
